import { DialogContent, Dialog, DialogActions, useMediaQuery, useTheme } from '@mui/material';
import { Anomaly } from 'front-office/view-models/common-certificate-form';
import { memo, useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';
import Table from 'shell/components/shared/table';
import { HeadCell } from 'shell/components/shared/table/types';
import { noop } from 'shell/utils/noop';

const headCells: HeadCell<Anomaly, keyof Anomaly>[] = [
  {
    label: 'Codice',
    id: 'code',
  },
  {
    label: 'Descrizione',
    id: 'description',
  },
  {
    label: 'Data inserimento',
    id: 'insertDate',
  },
];

interface AnomalieErrorModalProps {
  open: boolean;
  onClose: (open: boolean) => void;
  dataPersons?: Array<Anomaly>;
}

const AnomalieErrorModalComponent = ({
  open,
  onClose,
  dataPersons,
}: AnomalieErrorModalProps): React.ReactElement => {
  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return (
    <Dialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" backgroundColor="cdmBrand" color="white">
        Elenco note e anomalie
      </PmiDialogTitle>
      <DialogContent style={{ padding: '30px 24px' }}>
        {dataPersons?.length ? (
          <Table
            ariaLabel="Lista anomalie"
            page={page}
            rowsPerPage={rowsPerPage}
            body={dataPersons}
            count={dataPersons?.length}
            head={headCells}
            onSort={noop}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            onVisibilityPress={noop}
            orders={{}}
            isNotLayoutFixed
            noSort
            hideButtons
            minWidth={null}
          />
        ) : undefined}
      </DialogContent>
      <DialogActions>
        <PmiButton variant="outlined" color="cdmBrand" type="button" onClick={() => onClose(false)}>
          Ho Capito
        </PmiButton>
      </DialogActions>
    </Dialog>
  );
};

AnomalieErrorModalComponent.displayName = 'Modal error';

const AnomalieErrorModal = memo(AnomalieErrorModalComponent);

export default AnomalieErrorModal;
